var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout-gestao", {}, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c(
          "form",
          {
            attrs: {
              autocomplete: "off",
              method: "post",
              disabled: _vm.isLoading,
              "data-vv-scope": "form",
            },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.onBeforeSaveItem.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "row mb-3" }, [
              _c("div", { staticClass: "col-sm-auto" }, [
                _c("h1", { staticClass: "content-title" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.titleItem) +
                      "\n            "
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("nav", [
              _c(
                "div",
                {
                  staticClass: "nav nav-tabs nav-fill mb-3 sky-blue",
                  attrs: { id: "nav-tab", role: "tablist" },
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nav-item nav-link active",
                      attrs: {
                        "data-toggle": "tab",
                        href: "#" + _vm.tabs[0]["code"],
                        role: "tab",
                        "aria-selected": "true",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.localActive = _vm.tabs[0]
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.tabs[0]["name"]))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "nav-item nav-link",
                      attrs: {
                        id: "nav-parishes-tab",
                        "data-toggle": "tab",
                        href: "#" + _vm.tabs[1]["code"],
                        role: "tab",
                        "aria-controls": "nav-parishes",
                        "aria-selected": "false",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.localActive = _vm.tabs[1]
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.tabs[1]["name"]))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "nav-item nav-link",
                      attrs: {
                        id: "nav-users-tab",
                        "data-toggle": "tab",
                        href: "#" + _vm.tabs[2]["code"],
                        role: "tab",
                        "aria-controls": "nav-users",
                        "aria-selected": "false",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.localActive = _vm.tabs[2]
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.tabs[2]["name"]))]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tab-content", attrs: { id: "nav-tabContent" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    class: { "show active": _vm.localActive == _vm.tabs[0] },
                    attrs: {
                      id: `nav-${_vm.tabs[0]["code"]}`,
                      role: "tabpanel",
                      "aria-labelledby": `nav-${_vm.tabs[0]["code"]}-tab`,
                    },
                  },
                  [
                    _c("unity-general", {
                      attrs: {
                        vScope: "general",
                        onoff: _vm.lists.onoff,
                        propPageID: _vm.pageID,
                      },
                      model: {
                        value: _vm.form,
                        callback: function ($$v) {
                          _vm.form = $$v
                        },
                        expression: "form",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    class: { "show active": _vm.localActive == _vm.tabs[1] },
                    attrs: {
                      id: `nav-${_vm.tabs[1]["code"]}`,
                      role: "tabpanel",
                      "aria-labelledby": `nav-${_vm.tabs[1]["code"]}-tab`,
                    },
                  },
                  [
                    _c("unity-parishes", {
                      attrs: {
                        vScope: "parishes",
                        parishes: _vm.lists.parishes,
                        propPageID: _vm.pageID,
                      },
                      model: {
                        value: _vm.form.parishes,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "parishes", $$v)
                        },
                        expression: "form.parishes",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-pane fade",
                    class: { "show active": _vm.localActive == _vm.tabs[2] },
                    attrs: {
                      id: `nav-${_vm.tabs[2]["code"]}`,
                      role: "tabpanel",
                      "aria-labelledby": `nav-${_vm.tabs[2]["code"]}-tab`,
                    },
                  },
                  [
                    _c("unity-users", {
                      attrs: { vScope: "users", propPageID: _vm.pageID },
                      model: {
                        value: _vm.form.users,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "users", $$v)
                        },
                        expression: "form.users",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c("buttons-footer", {
              attrs: {
                enableButtons: !_vm.readonlyFormItem,
                cancelTitle: _vm.cancelTitle,
                submitTitle: _vm.submitTitle,
                isDisabled: _vm.isDisabled,
              },
              on: {
                save: _vm.onBeforeSaveItem,
                cancel: function ($event) {
                  return _vm.handleBack(
                    `${_vm.moduleInternalCode}.${_vm.pageID}`
                  )
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }